import * as mutations from './mutations'
import * as actions from './actions'
import array from '@/store/shared/array'

export default{
  namespaced: true,
  state () {
    return {
      html: false,
      source: false
    }
  },
  modules: {
    array
  },
  mutations,
  actions
}
